function yMap() {
	let YaMapsShown = false
	if (document.querySelector('.Map')) {
		window.addEventListener('scroll', () => {
			if (!YaMapsShown) {
				if (window.scrollY) {
					showYaMaps()
					document.getElementById('YaMaps').removeAttribute('style')
					document.getElementById('YaMaps').querySelector('span').style.display = 'none'
					YaMapsShown = true
				}
			}
		})
	}
}

function showYaMaps() {
	var script = document.createElement('script')
	script.type = 'text/javascript'
	script.src = 'https://api-maps.yandex.ru/2.1/?apikey=3a4315ee-7fbf-4437-88f8-3236cd2ebd58&lang=ru_RU'
	document.getElementById('YaMaps').appendChild(script)
	ymaps.ready(function () {
		const gg = document.querySelector('#YaMaps')
		var myMap = new ymaps.Map(gg, {
			center: [55.76, 37.64],
			zoom: 7,
		})
		myMap.behaviors.disable('scrollZoom')
		var objectManager = new ymaps.ObjectManager({
			clusterize: true,
		})
		myMap.geoObjects.add(objectManager)
		$.getJSON('/ajax/getSellingPoints.php').done(function (result) {
			objectManager.add(result.data)
			myMap.setBounds(objectManager.getBounds())
		})
	})
}